import { SimpleFrontendChart } from '@/interfaces/chart';

function getPointAndFigureWorkbenchURL(chart: SimpleFrontendChart): string {
  if (!chart.isPointAndFigureChart) {
    return '';
  }

  const cParameterValue = `${chart.symbol},${chart.styleCacheId}[J${chart.recid},Y]`;
  const encodedCParameterValue = encodeURIComponent(cParameterValue).replace(/!/g, '%21').toLowerCase();

  return `/freecharts/pnf.php?c=${encodedCParameterValue}&listNum=${chart.chartListListNum}`;
}

export function usePointAndFigureCharts() {
  return {
    getPointAndFigureWorkbenchURL
  };
}
